import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withKeys as _withKeys, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "sticky-table__cell__separator" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "dialog-title" }, "Информация", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Описание", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Рейтинги", -1)
const _hoisted_5 = { class: "dialog-test__ratings-row dialog-test__row" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "dialog-test__input-label-before-first" }, " Имя ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "dialog-test__input-label-before" }, " Рейтинг ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "dialog-test__input-label-before" }, "%", -1)
const _hoisted_9 = { class: "dialog-test__row" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "base-btn dialog-test__add-btn" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "dialog-test__input-label-before-first" }, " Имя ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "dialog-test__input-label-before" }, " Рейтинг ", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "dialog-test__input-label-before" }, "%", -1)
const _hoisted_16 = { class: "dialog-test__row" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "expanded-label" }
const _hoisted_20 = { class: "dialog-test__input-orange" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "dialog-test__row-group__border" }, null, -1)
const _hoisted_22 = { class: "dialog-test__row dialog-test__row-without-padding" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", null, "Итого количество вопросов:", -1)
const _hoisted_24 = { class: "dialog-test__ratings-row dialog-test__row dialog-test__fix-height dialog-test__input-orange" }
const _hoisted_25 = ["disabled"]

import AdminApi from "@/api/AdminApi";
import { computed, onMounted, ref } from "vue";

import ITest from "@/interfaces/ITest";
import IGroupQuestions from "@/interfaces/IGroupQuestions";
import IScore from "@/interfaces/IScore";


export default /*#__PURE__*/_defineComponent({
  __name: 'TestsetsTabComponent',
  setup(__props, { expose: __expose }) {

const api = new AdminApi();
const tests = ref([]);
const loading = ref(false);
const testEditDialog = ref(false);
const currentTest = ref({} as ITest);
const groups = ref([] as Array<IGroupQuestions>);
const selectedGroups = ref([] as Array<IGroupQuestions>);
const newScore = ref({} as IScore);
const isNewTest = ref(false);
const isFillInfo = computed(() => {
  return (
    currentTest.value.name != "" &&
    currentTest.value.scores.length > 0 &&
    selectedGroups.value.some((group: any) => group.checked)
  );
});
const commonCountOfQuestions = computed(() => {
  let count = 0;
  if (selectedGroups.value.find((group: any) => group.checked)) {
    selectedGroups.value
      .filter((group: any) => group.checked)
      .forEach((group: any) => {
        count += Number(group.questionCountInTestset);
      });
  }
  return count > 0 ? count.toString() : 0;
});

const pagination = ref({
  descending: false,
  page: 1,
  rowsPerPage: 7,
});

const columns = [
  {
    name: "id",
    required: true,
    label: "ID",
    align: "left",
    style: "width: 50px",
    field: (row: { id: any }) => row.id,
    sortable: true,
  },
  {
    name: "name",
    required: true,
    label: "Название теста",
    align: "left",
    field: "name",
    sortable: true,
  },
];

async function saveTest() {
  currentTest.value.testSetQuestionsGroups = [];
  currentTest.value.scores = currentTest.value.scores.map((s: any) => {
    return {
      title: s.title,
      scoreMultiply: s.scoreMultiply / 100,
      testSetId: currentTest.value.id,
      id: s.id,
    };
  });

  selectedGroups.value
    .filter((group: any) => group.checked)
    .forEach((group: any) => {
      currentTest.value.testSetQuestionsGroups.push({
        questionCount: Number(group.questionCountInTestset),
        questionGroupId: group.questionGroupId,
        name: group.name,
        testSetId: currentTest.value.id,
      });
    });

  isNewTest.value
    ? await api.createTest(currentTest.value)
    : await api.editTest(currentTest.value);

  await getTests();

  for (const key in currentTest.value) {
    delete currentTest.value[key];
  }

  testEditDialog.value = false;
  selectedGroups.value = [];
}

function addRating(value: IScore) {
  currentTest.value.scores.push(value);
}

function getRatingClass(score: number) {
  if (score < 40) {
    return "dialog-test__red";
  } else if (score >= 40 && score < 80) {
    return "dialog-test__yellow";
  } else {
    return "dialog-test__green";
  }
}

async function openTestEdit(event: any, row: any, index: any) {
  await api.loadTest(row.id).then((res) => {
    testEditDialog.value = true;
    currentTest.value = res;
    currentTest.value.scores = res.scores.map((s: any) => {
      return { title: s.title, scoreMultiply: s.scoreMultiply * 100, id: s.id };
    });
  });

  await loadQuestionGroups();
}

async function openTestCreate() {
  testEditDialog.value = true;
  isNewTest.value = true;
  currentTest.value = {
    id: tests.value.length + 1,
    name: "",
    testSetQuestionsGroups: [],
    scores: [],
    description: "",
  };
  await loadQuestionGroups();
}

function cancelEditDialog() {
  testEditDialog.value = false;
}

async function loadQuestionGroups() {
  selectedGroups.value = [];
  await api.loadQuestionGroups().then((res) => {
    groups.value = res;
    if (currentTest.value.testSetQuestionsGroups?.length === 0) {
      groups.value.forEach((g: IGroupQuestions) => {
        selectedGroups.value.push({
          checked: false,
          questionCount: g.questionCount,
          questionCountInTestset: 0,
          questionGroupId: g.questionGroupId,
          name: g.name,
        });
      });
    } else {
      groups.value.forEach((g: IGroupQuestions) => {
        const index = currentTest.value.testSetQuestionsGroups?.findIndex(
          (el: IGroupQuestions) => el.questionGroupId == g.questionGroupId
        );
        if (
          currentTest.value.testSetQuestionsGroups?.find(
            (el: IGroupQuestions) => el.questionGroupId == g.questionGroupId
          ) != undefined
        ) {
          selectedGroups.value.push({
            checked: true,
            questionCount: g.questionCount,
            questionCountInTestset:
              currentTest.value.testSetQuestionsGroups[index].questionCount ||
              0,
            questionGroupId: g.questionGroupId,
            name: g.name,
          });
        } else {
          selectedGroups.value.push({
            checked: false,
            questionCount: g.questionCount,
            questionCountInTestset: 0,
            questionGroupId: g.questionGroupId,
            name: g.name,
          });
        }
      });
    }
  });
}

async function getTests() {
  loading.value = true;
  await api.loadTests().then((res) => {
    tests.value = res;
    loading.value = false;
  });
}

function editRating(value: any) {
  let currentRatingIndex = currentTest.value.scores.findIndex(
    (item) => item.id == value.id
  );
  currentTest.value.scores[currentRatingIndex].title = value.title;
  currentTest.value.scores[currentRatingIndex].scoreMultiply =
    value.scoreMultiply;
}

function deleteRating(value: any) {
  let currentRatingIndex = currentTest.value.scores.findIndex(
    (item) => item.id == value.id
  );
  currentTest.value.scores.splice(currentRatingIndex, 1);
}

__expose({
  openTestCreate,
});

onMounted(async () => {
  await getTests();
});

return (_ctx: any,_cache: any) => {
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_editor = _resolveComponent("q-editor")!
  const _component_q_popup_edit = _resolveComponent("q-popup-edit")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_table, {
      class: "sticky-table",
      flat: "",
      ref: "tableRef",
      title: "",
      rows: tests.value,
      columns: columns,
      loading: loading.value,
      "row-key": "userId",
      pagination: pagination.value,
      "onUpdate:pagination": _cache[0] || (_cache[0] = ($event: any) => ((pagination).value = $event)),
      onRowDblclick: openTestEdit
    }, {
      "body-cell": _withCtx((props) => [
        _createVNode(_component_q_td, {
          class: "sticky-table__cell",
          props: props
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(props.value) + " ", 1),
            _hoisted_1
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      _: 1
    }, 8, ["rows", "loading", "pagination"]),
    _createVNode(_component_q_dialog, {
      class: "dialog-with-checkbox",
      modelValue: testEditDialog.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((testEditDialog).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, {
          style: {"width":"80vw","max-width":"90vw"},
          class: "dialog-test"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, { class: "row items-center q-pb-none" }, {
              default: _withCtx(() => [
                _hoisted_2,
                _createVNode(_component_q_space),
                _withDirectives(_createVNode(_component_q_btn, {
                  icon: "close",
                  flat: "",
                  round: "",
                  dense: ""
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _hoisted_3,
                _createVNode(_component_q_input, {
                  outlined: "",
                  modelValue: currentTest.value.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentTest.value.name) = $event)),
                  class: "dialog-test__input dialog-test__input-orange"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_q_editor, {
                  class: "dialog-test__input",
                  modelValue: currentTest.value.description,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((currentTest.value.description) = $event)),
                  "min-height": "5rem",
                  toolbar: [
            ['bold', 'italic'],
            ['unordered', 'ordered'],
            ['undo', 'redo'],
            ['viewsource'],
          ]
                }, null, 8, ["modelValue"]),
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentTest.value.scores, (rating, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass([getRatingClass(rating.scoreMultiply), 'base-btn ']),
                      key: rating.id
                    }, [
                      _createTextVNode(_toDisplayString(rating.title) + " ", 1),
                      _createVNode(_component_q_popup_edit, {
                        modelValue: currentTest.value.scores[i],
                        "onUpdate:modelValue": ($event: any) => ((currentTest.value.scores[i]) = $event),
                        "label-set": "Сохранить",
                        "label-cancel": "Удалить",
                        cover: false,
                        fit: false,
                        onSave: editRating
                      }, {
                        default: _withCtx((scope) => [
                          _createVNode(_component_q_input, {
                            outlined: "",
                            class: "dialog-test__input dialog-test__input-rating-edit",
                            modelValue: scope.value.title,
                            "onUpdate:modelValue": ($event: any) => ((scope.value.title) = $event),
                            dense: "",
                            autofocus: "",
                            onKeyup: _withKeys(scope.set, ["enter"])
                          }, {
                            before: _withCtx(() => [
                              _hoisted_6
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue", "onKeyup"]),
                          _createVNode(_component_q_input, {
                            outlined: "",
                            class: "dialog-test__input dialog-test__input-rating-edit",
                            type: "number",
                            modelValue: scope.value.scoreMultiply,
                            "onUpdate:modelValue": ($event: any) => ((scope.value.scoreMultiply) = $event),
                            dense: "",
                            autofocus: "",
                            rules: [
                  (val) =>
                    (val > 0 && val <= 100) ||
                    'Число должно быть в диапазоне от 1 до 100',
                ],
                            onKeyup: _withKeys(scope.set, ["enter"])
                          }, {
                            before: _withCtx(() => [
                              _hoisted_7
                            ]),
                            after: _withCtx(() => [
                              _hoisted_8
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue", "rules", "onKeyup"]),
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", {
                              class: "base-btn base-btn-cancel",
                              onClick: ($event: any) => (deleteRating(scope.value))
                            }, " Удалить ", 8, _hoisted_10),
                            _createElementVNode("div", {
                              class: "base-btn base-btn-yellow",
                              onClick: scope.set
                            }, " Сохранить ", 8, _hoisted_11)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue"])
                    ], 2))
                  }), 128)),
                  _createElementVNode("div", _hoisted_12, [
                    _createTextVNode(" Добавить "),
                    _createVNode(_component_q_popup_edit, {
                      modelValue: newScore.value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((newScore).value = $event)),
                      "label-set": "Сохранить",
                      "label-cancel": "Удалить",
                      cover: false,
                      fit: false,
                      onSave: addRating
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_q_input, {
                          outlined: "",
                          class: "dialog-test__input dialog-test__input-rating-edit",
                          modelValue: scope.value.title,
                          "onUpdate:modelValue": ($event: any) => ((scope.value.title) = $event),
                          dense: "",
                          autofocus: "",
                          onKeyup: _withKeys(scope.set, ["enter"])
                        }, {
                          before: _withCtx(() => [
                            _hoisted_13
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue", "onKeyup"]),
                        _createVNode(_component_q_input, {
                          outlined: "",
                          class: "dialog-test__input dialog-test__input-rating-edit",
                          type: "number",
                          modelValue: scope.value.scoreMultiply,
                          "onUpdate:modelValue": ($event: any) => ((scope.value.scoreMultiply) = $event),
                          dense: "",
                          autofocus: "",
                          rules: [
                  (val) =>
                    (val > 0 && val <= 100) ||
                    'Число должно быть в диапазоне от 1 до 100',
                ],
                          onKeyup: _withKeys(scope.set, ["enter"])
                        }, {
                          before: _withCtx(() => [
                            _hoisted_14
                          ]),
                          after: _withCtx(() => [
                            _hoisted_15
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue", "rules", "onKeyup"]),
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", {
                            class: "base-btn base-btn-cancel",
                            onClick: ($event: any) => (scope.cancel())
                          }, " Отмена ", 8, _hoisted_17),
                          _createElementVNode("div", {
                            class: "base-btn base-btn-yellow",
                            onClick: ($event: any) => (scope.set())
                          }, " Сохранить ", 8, _hoisted_18)
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]),
                _createVNode(_component_q_expansion_item, {
                  style: {"width":"100%"},
                  "expand-separator": "",
                  "expand-icon": "chevron_right",
                  "expanded-icon": "expand_more"
                }, {
                  header: _withCtx(() => [
                    _createElementVNode("p", _hoisted_19, [
                      _createTextVNode(" Группы вопросов "),
                      _createElementVNode("span", _hoisted_20, "(" + _toDisplayString(selectedGroups.value.filter((group) => group.checked).length) + " выбрано)", 1)
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_q_card, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_card_section, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedGroups.value, (group, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "dialog-test__row dialog-test__row-group",
                                key: index
                              }, [
                                _createVNode(_component_q_checkbox, {
                                  modelValue: selectedGroups.value[index].checked,
                                  "onUpdate:modelValue": ($event: any) => ((selectedGroups.value[index].checked) = $event),
                                  label: 
                    group.name + ' (' + group.questionCount + ' вопросов)'
                  
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]),
                                _createVNode(_component_q_input, {
                                  outlined: "",
                                  modelValue: selectedGroups.value[index].questionCountInTestset,
                                  "onUpdate:modelValue": ($event: any) => ((selectedGroups.value[index].questionCountInTestset) = $event),
                                  type: "number",
                                  rules: [
                    (val) =>
                      (val <= group.questionCount && val > 0) ||
                      'Max: ' + group.questionCount + ' Min: 0',
                  ],
                                  class: "dialog-test__input dialog-test__input-orange"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"]),
                                _hoisted_21
                              ]))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("div", _hoisted_24, _toDisplayString(commonCountOfQuestions.value), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, { class: "dialog-test__row" }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  class: "base-btn base-btn-cancel",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (cancelEditDialog()))
                }, " Отмена "),
                _createElementVNode("button", {
                  class: "base-btn base-btn-yellow",
                  disabled: !isFillInfo.value,
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (saveTest()))
                }, " Сохранить ", 8, _hoisted_25)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})